import React, { useEffect } from "react";
import "./style.scss";

import { convertSnakeCaseToDefault } from "../../../utils/helpers/string";
import Card from "../Card";

function TierHeader({ tier }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formattedTitles = [
    "Starting Balance",
    "Profit Share",
    "Profit Target",
    "Max Position",
    "Max Loss",
    "Payout",
    "Min Trading Days",
    "Micro Scaling",
    "Consistency Rule",
  ];

  // Helper to check for Zero Plan
  const isZeroPlan = tier?.name?.toLowerCase() === "zero plan";
  const isInstantFunding = tier?.name?.toLowerCase() === "direct plan";

  return (
    <Card className="tierheader-container">
      <h3 style={{ visibility: "hidden" }}></h3>
      {formattedTitles.map((item, index) => (
        <React.Fragment key={index}>
          <p>
            {item === "ea"
              ? "EA"
              : item === "Profit Target" && isInstantFunding
              ? "Payout Target"
              : convertSnakeCaseToDefault(item)}
          </p>
          {/* Insert Max Daily Loss after Max Loss for Zero Plan */}
          {item === "Max Loss" && isZeroPlan && <p>{"Max Daily Loss"}</p>}
        </React.Fragment>
      ))}
    </Card>
  );
}

export default TierHeader;
